/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_TitleInputs */

const da_pricing_title = /** @type {(inputs: Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser`)
};

/** @type {(inputs: Pricing_TitleInputs) => LocalizedString} */
const en_pricing_title = da_pricing_title;

/**

* @param {Pricing_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const pricing_title = /** @type {((inputs?: Pricing_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_title(inputs)
	return /** @type {LocalizedString} */ ("Priser")
});